<template>
  <div
    :class="{
      'e-message--read': data.read,
      'e-message--answered': !data.draft && data.outgoing,
      'e-message--draft': data.draft && data.outgoing,
      'e-message--open': isOpen
    }"
    class="e-message e-message--ingoing"
  >
    <div v-if="isLoading" class="e-message__loading">
      <loading />
    </div>

    <div class="e-message__meta">
      <div
        class="e-message__author"
        v-text="data.outgoing ? $t('system.me') : data.author"
      />

      <time :datetime="data.timestamp" class="e-message__date">
        {{ data.timestamp | simpledate }}
      </time>
    </div>

    <div class="e-message__body">
      <component
        :is="messageStatusIcon"
        class="e-message__icon"
        :class="{ 'e-message__icon--finished': data.status === 'finished' }"
        :aria-label="$t('aria.dialog.icon.' + messageStatusIcon)"
      />

      <h3
        class="e-message__subject"
        v-text="data.subject || $t('system.noSubject')"
      />

      <div
        v-if="data.threadCount"
        class="e-message__count"
        v-text="data.threadCount"
      />

      <p class="e-message__content" v-html="trimContent(data.body)" />
    </div>
  </div>
</template>

<script>
import Loading from 'atoms/Loading/Loading'

// Icons
import IconArrowIncomingFull from 'assets/icons/arrow-incoming-full.svg'
import IconArrowIncomingLine from 'assets/icons/arrow-incoming-line.svg'
import IconArrowOutgoingLine from 'assets/icons/arrow-outgoing-line.svg'
import IconPencil from 'assets/icons/pencil-outline.svg'
import IconFinished from 'assets/icons/arrows-circle-check.svg'

export default {
  name: 'MessageListItem',
  components: {
    IconArrowIncomingFull,
    IconArrowIncomingLine,
    IconArrowOutgoingLine,
    IconPencil,
    IconFinished,
    Loading
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messageStatusIcon() {
      if (this.data.status === 'finished') {
        return 'IconFinished'
      }
      if (this.data.outgoing) {
        if (this.data.draft) {
          return 'IconPencil'
        }
        return 'IconArrowOutgoingLine'
      }
      if (this.data.read) {
        return 'IconArrowIncomingLine'
      }
      return 'IconArrowIncomingFull'
    }
  },
  methods: {
    trimContent(content) {
      let simpleContent = content
        .replace(/<br\s*[\/]?>/gi, ' ') // eslint-disable-line
        .replace('</div><div>', ' ')
        .replace('<div>', ' ')
      const div = document.createElement('div')
      div.innerHTML = simpleContent
      simpleContent = div.textContent || div.innerText || ''
      return simpleContent.length > 100
        ? `${simpleContent.substring(0, 100)}...`
        : simpleContent
    }
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/messagepreview';
</style>
